module.exports = __webpack_public_path__ + "static/media/male-and-female.4fa4eaeb.png";